import { getStateKey } from '@utils/state';

const PROD: string = 'production';
const DEV: string = 'develop';
const PRE: string = 'prepro';

const isPre = () => {
  const INDEX_OF_VALUE = -1;
  const HOST = 'prepro-public.shopadvizor.net';
  const PRE_HOST_CRF = 'communaute-testerdesproduits-preprod.carrefour.fr';
  return (
    window.location.host.indexOf(HOST) !== INDEX_OF_VALUE ||
    window.location.host.indexOf(PRE_HOST_CRF) !== INDEX_OF_VALUE
  );
};

const isProd = () => {
  const INDEX_OF_VALUE = -1;
  const PRODUCTION_HOST = 'public.shopadvizor.com';
  const PRODUCTION_HOST_SAZ = '34.141.133.23';
  const PRODUCTION_HOST_CRF = 'communaute-testerdesproduits.carrefour.fr';

  return (
    window.location.host.indexOf(PRODUCTION_HOST) !== INDEX_OF_VALUE ||
    window.location.host.indexOf(PRODUCTION_HOST_CRF) !== INDEX_OF_VALUE ||
    window.location.host.indexOf(PRODUCTION_HOST_SAZ) !== INDEX_OF_VALUE
  );
};

const getEnvironment = () => {
  if (isProd()) return PROD;
  if (isPre()) return PRE;
  return DEV;
};

const getOAuthUrl = () => {
  const currentEnv = getEnvironment();
  switch (currentEnv) {
    case PROD:
      return process.env.REACT_APP_OAUTH_URL_PROD;
    case PRE:
      return process.env.REACT_APP_OAUTH_URL_PRE;
    default:
      return process.env.REACT_APP_OAUTH_URL;
  }
};

const getCatalogOAuthUrl = () => {
  const currentEnv = getEnvironment();
  switch (currentEnv) {
    case PROD:
      return process.env.REACT_APP_CATALOG_OAUTH_URL_PROD;
    case PRE:
      return process.env.REACT_APP_CATALOG_OAUTH_URL_PRE;
    default:
      return process.env.REACT_APP_CATALOG_OAUTH_URL;
  }
};

const getGwUrl = () => {
  const currentEnv = getEnvironment();
  switch (currentEnv) {
    case PROD:
      return process.env.REACT_APP_API_URL_PROD;
    case PRE:
      return process.env.REACT_APP_API_URL_PRE;
    default:
      return process.env.REACT_APP_API_URL;
  }
};

const getCatalogGwUrl = () => {
  const currentEnv = getEnvironment();
  switch (currentEnv) {
    case PROD:
      return process.env.REACT_APP_CATALOG_URL_PROD;
    case PRE:
      return process.env.REACT_APP_CATALOG_URL_PRE;
    default:
      return process.env.REACT_APP_CATALOG_URL;
  }
};

const getSsoUrl = (campaign?: string | null) => {
  const currentEnv = getEnvironment();
  const stateId = campaign ? `&state=${getStateKey()}:${campaign}` : `&state=${getStateKey()}`;
  switch (currentEnv) {
    case PROD:
      return process.env.REACT_APP_SSO_URL_PROD + stateId;
    case PRE:
      return process.env.REACT_APP_SSO_URL_PRE + stateId;
    default:
      return process.env.REACT_APP_SSO_URL + stateId;
  }
};

const getMockSsoUrl = (campaign?: string | null) => {
  const currentEnv = getEnvironment();
  const stateId = campaign ? `&state=${getStateKey()}:${campaign}` : `&state=${getStateKey()}`;
  switch (currentEnv) {
    case PROD:
      return null;
    case PRE:
      return process.env.REACT_APP_OUT_URL_PRE_MOCK + stateId;
    default:
      return process.env.REACT_APP_SSO_URL + stateId;
  }
};

const getLogOutUrl = () => {
  const currentEnv = getEnvironment();
  switch (currentEnv) {
    case PROD:
      return process.env.REACT_APP_OUT_URL_PROD;
    case PRE:
      return process.env.REACT_APP_OUT_URL_PRE;
    default:
      return process.env.REACT_APP_OUT_URL;
  }
};

const getStartUrl = () => {
  const currentEnv = getEnvironment();
  switch (currentEnv) {
    case PROD:
      return process.env.REACT_APP_START_URL_PROD;
    case PRE:
      return process.env.REACT_APP_START_URL_PRE;
    default:
      return process.env.REACT_APP_START_URL;
  }
};

const getSpaUrl = () => {
  const currentEnv = getEnvironment();

  switch (currentEnv) {
    case PROD:
      return process.env.REACT_APP_SPA_URL_PROD;
    case PRE:
      return process.env.REACT_APP_SPA_URL_PRE;
    default:
      return process.env.REACT_APP_SPA_URL;
  }
};

const getSpaCampaignUrlMock = (campaign: string) => {
  return getMockSsoUrl(campaign);
};
const getLegacySurveyUrl = () => {
  const currentEnv = getEnvironment();
  switch (currentEnv) {
    case PROD:
      return process.env.REACT_APP_URL_LEGACY_SURVEY_SERVICE_PROD;
    case PRE:
      return process.env.REACT_APP_URL_LEGACY_SURVEY_SERVICE_PRE;
    case DEV:
      return process.env.REACT_APP_URL_LEGACY_SURVEY_SERVICE_DEVELOP;
    default:
      return process.env.REACT_APP_URL_LEGACY_SURVEY_SERVICE_PRE;
  }
};

const getClientSecret = () => {
  const currentEnv = getEnvironment();
  switch (currentEnv) {
    case PROD:
      return process.env.REACT_APP_CLIENT_SECRET_PROD;
    case PRE:
      return process.env.REACT_APP_CLIENT_SECRET_PRE;
    default:
      return process.env.REACT_APP_CLIENT_SECRET;
  }
};

const getCatalogClientSecret = () => {
  const currentEnv = getEnvironment();
  switch (currentEnv) {
    case PROD:
      return process.env.REACT_APP_CATALOG_SECRET_PROD;
    case PRE:
      return process.env.REACT_APP_CATALOG_SECRET_PRE;
    default:
      return process.env.REACT_APP_CATALOG_SECRET;
  }
};

const getMonavisUrl = () => {
  const currentEnv = getEnvironment();
  switch (currentEnv) {
    case PROD:
      return process.env.REACT_APP_MONAVIS_URL_PROD;
    case PRE:
      return process.env.REACT_APP_MONAVIS_URL_PRE;
    default:
      return process.env.REACT_APP_MONAVIS_URL;
  }
};

const getSurveyUrl = () => {
  const currentEnv = getEnvironment();
  switch (currentEnv) {
    case PROD:
      return process.env.REACT_APP_SURVEY_URL_PROD;
    case PRE:
      return process.env.REACT_APP_SURVEY_URL_PRE;
    default:
      return process.env.REACT_APP_SURVEY_URL;
  }
};

const getSyncUrl = () => {
  const currentEnv = getEnvironment();
  switch (currentEnv) {
    case PROD:
      return process.env.REACT_APP_SYNC_URL_PROD;
    case PRE:
      return process.env.REACT_APP_SYNC_URL_PRE;
    default:
      return process.env.REACT_APP_SYNC_URL;
  }
};

const getLogoUrl = (): string | undefined => {
  const currentEnv = getEnvironment();
  switch (currentEnv) {
    case PROD:
      return process.env.REACT_APP_LOGO_URL_PROD;
    case PRE:
      return process.env.REACT_APP_LOGO_URL_PRE;
    default:
      return process.env.REACT_APP_LOGO_URL;
  }
};

export {
  PROD,
  PRE,
  DEV,
  getEnvironment,
  getOAuthUrl,
  getCatalogOAuthUrl,
  getGwUrl,
  getCatalogGwUrl,
  getSsoUrl,
  getMockSsoUrl,
  getStartUrl,
  getSpaUrl,
  getSpaCampaignUrlMock,
  getLegacySurveyUrl,
  getClientSecret,
  getCatalogClientSecret,
  getLogOutUrl,
  getMonavisUrl,
  getSurveyUrl,
  getSyncUrl,
  getLogoUrl,
  isPre,
  isProd,
};
